<template>
  <section id="OrderHistory">
    

    <div id="acctOrders">
      <div class="container">
        <div id="ao-table">
          <div class="row align-items-center">
            <div class="col-lg-3 mb-4 mb-lg-0">
              <h2>Recent Orders</h2>
            </div>
            

            <div class="col-lg-3 mb-4 mb-lg-0">
              <router-link to="/account/savedcarts?tab=quotes" class="btn btn-dark"
                >Quote History</router-link
              >
            </div>
          </div>
          <!-- No company selected -->
          <div class="row" v-if="!loading && noCompany">
            <div class="col-12 mt-4">
              <div class="no-orders-notice">
                <p>Please select a company from the dropdown above to view your order history.</p>
              </div>
            </div>
          </div>

          

          <!-- No orders but quotes may exist — redirecting -->
          <div class="row" v-if="!loading && !noCompany && orders.length === 0 && !noHistory">
            <div class="col-12 mt-4">
              <div class="no-orders-notice">
                <h3>No orders found.</h3>
                <p>Redirecting to your Quote History...</p>
              </div>
            </div>
          </div>

          <b-table
            id="ordersTable"
            :per-page="0"
            :current-page="currentPage"
            stacked="lg"
            :fields="ordersFields"
            :items="orders"
            responsive="sm"
            v-if="!loading && orders.length > 0"
          >
            <template v-slot:head(dateCreated)="data">
              <p class="text-center mb-0">{{ data.label }}</p>
              <div class="ui input">
                <date-picker
                  v-model="search.fields.date"
                  format="MM/DD/YYYY"
                  :placeholder="data.label"
                  :disabled-date="disabledDate"
                ></date-picker>
              </div>
            </template>
            <template v-slot:head(id)="data">
              <p class="text-center mb-0">{{ data.label }}</p>
              <div class="ui input">
                <input
                  type="text"
                  v-model="search.fields.order"
                  :placeholder="data.label"
                />
              </div>
            </template>
            <template v-slot:head(company.code)="data">
              <p class="text-center mb-0">{{ data.label }}</p>
              <div class="ui input">
                <input
                  type="text"
                  v-model="search.fields.companyCode"
                  :placeholder="data.label"
                  readonly
                />
              </div>
            </template>
            <template v-slot:head(cost)="data">
              <p class="text-center mb-0">{{ data.label }}</p>
              <div class="ui input">
                <input
                  type="number"
                  v-model="search.fields.orderTotal"
                  :placeholder="data.label"
                />
              </div>
            </template>
            <template v-slot:head(reorder)="data">
              <p class="text-center mb-0">Po Number</p>
              <div class="ui input">
                <input
                  type="text"
                  v-model="search.poNumber"
                  placeholder="Po Number"
                />
                <span
                  class="fa fa-search icon-button"
                  id="searchFilter"
                  @click="doFilter"
                ></span>
                <b-tooltip target="searchFilter" triggers="hover">
                  Serach Filter
                </b-tooltip>
                <span
                  class="fa fa-refresh icon-button"
                  id="clearFilter"
                  @click="clearFilter"
                ></span>
                <b-tooltip target="clearFilter" triggers="hover">
                  Clear Filter
                </b-tooltip>
              </div>
            </template>
            <template v-slot:head(status)="data">
              <p class="text-center mb-0">{{ data.label }}</p>
              <div class="ui input">
                <input
                  type="text"
                  v-model="search.fields.status"
                  :placeholder="data.label"
                />
              </div>
            </template>

            <!-- A virtual column -->
            <template v-slot:cell(dateCreated)="data">
              {{ data.item.dateCreated | formatDate }}
            </template>

            <!-- A custom formatted column -->
            <template v-slot:cell(id)="data">
              {{ data.item.id }}
            </template>

            <template v-slot:cell(company.code)="data">
              {{ data.item.company.code }}
            </template>

            <!-- Optional default data cell scoped slot -->
            <template v-slot:cell(cost)="data">
              {{ data.item.cost | currency }}
            </template>

            <template v-slot:cell(status)="data">
              {{ data.item.status }}
            </template>

            <template v-slot:cell(reorder)="data">
              <button
                class="btn btn-dark table-btn"
                type="submit"
                @click="viewOrder(data.item.id)"
              >
                Review Order
              </button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="ordersTable"
          ></b-pagination>

          <div class="table-notice">
            *Please note that pricing is subject to change on re-orders.
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FeApiService from "@/assets/js/FeApiService";
const apiService = new FeApiService();
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Vue from "vue";
import Vue2Filters from "vue2-filters";
import moment from "moment";

Vue.use(Vue2Filters);
export default {
  name: "OrderHistory",
  components: { DatePicker },
  mounted() {
    // Check if we were redirected back from Quote History with no quotes
    this.noHistory = this.$route.query.noQuotes === 'true';

    if (!localStorage.companyId) {
      this.loading = false;
      this.noCompany = true;
      return;
    }

    if (localStorage.companyId) {
      apiService.getCompanyList().then(function (data) {
        var match = data.find(function (c) { return c.value == localStorage.companyId; });
        if (match) {
          var codeMatch = match.text.match(/\(([^)]+)\)/);
          this.search.fields.companyCode = codeMatch ? codeMatch[1] : '';
        }
      }.bind(this));
    }
    this.fetchData().catch((error) => {
      console.error(error);
    });
  },
  data() {
    return {
      search: {
        filterText: "",
        filters: "",
        fields: {
          date: "",
          order: "",
          companyCode: "",
          status: "",
          orderTotal: "",
        },
        inactive: false,
        poNumber: "",
      },
      loading: true,
      noHistory: false,
      noCompany: false,
      currentPage: 1,
      perPage: 10,
      rows: 0,
      sortBy: "dateCreated|desc",
      orders: [],
      ordersFields: [
        { key: "dateCreated", label: "Date", searchKey: "date", search: "" },
        { key: "id", label: "Order #", searchKey: "order", search: "" },
        {
          key: "company.code",
          label: "Selected Company Code",
          searchKey: "companyCode",
          search: "",
        },
        {
          key: "cost",
          label: "Order Total",
          searchKey: "orderTotal",
          search: "",
        },
        { key: "status", label: "Status", searchKey: "status", search: "" },
        { key: "reorder", label: "Re-Order*" },
      ],
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      apiService
        .getOrders({
          page: this.currentPage,
          per_page: this.perPage,
          sortBy: this.sortBy,
          filter: this.search.filterText,
          poNumber: this.search.poNumber,
          companyId: localStorage.companyId || '',
        })
        .then((res) => {
          this.rows = res.total;
          this.currentPage = res.current_page;
          this.perPage = res.per_page;
          this.orders = Array.from(res.data[0]);
          this.loading = false;

          // No orders — redirect to Quote History (unless we already know there are no quotes)
          if (this.orders.length === 0 && !this.noHistory) {
            var self = this;
            setTimeout(function () {
              self.$router.replace('/account/savedcarts?tab=quotes&fromOrders=true');
            }, 2000);
          }
        })
        .then((orders) => orders);
    },
    viewOrder(id) {
      this.$router.push({
        name: "Order Details",
        params: {
          id: id,
        },
      });
    },
    disabledDate(date) {
      const maxDate = new Date(); // Set your maximum date here
      return date > maxDate;
    },
    clearFilter() {
      let filterText = [];
      Object.keys(this.search.fields).forEach((item) => {
        this.search.fields[item] = "";
      });
      filterText = "";
      this.search.poNumber = "";
      this.search = Object.assign({}, this.search, { filterText });
      this.fetchData();
    },
    doFilter() {
      let filterText = [];
      Object.keys(this.search.fields).forEach((item) => {
        if (item === "date" && this.search.fields[item]) {
          const dateFormat = moment(this.search.fields[item]).format(
            "MM/DD/YYYY"
          );
          filterText.push(`${item}-${dateFormat}`);
        } else if (this.search.fields[item]) {
          filterText.push(`${item}-${this.search.fields[item]}`);
        }
      });
      filterText = filterText.join("|");
      if (this.search.filterText !== filterText) {
        this.search = Object.assign({}, this.search, { filterText });
      }
      this.fetchData();
    },
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch((error) => {
          console.error(error);
        });
      },
    },
  },
};
</script>
<style scoped>
/* ===== ICONS (SEARCH / CLEAR) ===== */
.icon-button {
  padding-top: 1rem;
  padding-left: 10px;
  cursor: pointer;
  color: #333 !important;
  font-size: 14px;
}

.icon-button:hover {
  color: #c0392b !important;
}

/* ===== INPUTS (FILTER ROW CLEANUP) ===== */
.ui.input input {
  font-size: 13px;
  height: 34px;
}

/* ===== DATE PICKER WIDTH ===== */
.ui.input .mx-datepicker {
  width: 100%;
  min-width: 160px;
}

/* ===== REVIEW ORDER BUTTON ===== */
.table-btn {
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  white-space: nowrap;
}

.table-btn:hover {
  background-color: #c0392b !important;
  border-color: #c0392b !important;
}

/* ===== TABLE HEADER CLEANUP ===== */
#ordersTable th {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* ===== TABLE ROW TEXT ===== */
#ordersTable td {
  font-size: 13px;
  color: #333;
}

/* ===== PAGINATION CLEANUP ===== */
.pagination {
  justify-content: center;
  margin-top: 20px;
}

/* ===== EMPTY STATE ===== */
.no-orders-notice {
  text-align: center;
  padding: 30px 20px;
}

.no-orders-notice h3 {
  margin-bottom: 10px;
}

.no-orders-notice p {
  color: #999;
  font-size: 14px;
}

/* ===== NOTICE TEXT ===== */
.table-notice {
  margin-top: 15px;
  font-size: 12px;
  color: #c0392b;
  text-align: right;
}
</style>